import React from "react";
import { Row, Col } from "reactstrap";

const ThankYou = (_) => {
  return (
    <div>
      <Row noGutters className="text-center">
        <Col>
          <p className="thanks-header">Thank You!</p>
          <i className="fas fa-pizza-slice thank-you-pizza"></i>
          <p className="thanks-subtext">
            Vous devriez recevoir un courriel contenant les détails de votre réservation.
          </p>
        </Col>
      </Row>
    </div>
  );
};

export default ThankYou;
